import VlocHistoryDetails from 'features/lineOfCredit/screens/historyDetails/VlocHistoryDetails';
import React from 'react';

export default function Page() {
  return <VlocHistoryDetails />;
}
